import Vue from 'vue';
import { Checkbox } from 'element-ui';

/**
 * 此marco提供一组更详细的文本设定方案,允许通过配置方式改善原来body的默认黑色文本
 */
interface opt {
    renderer: (row) => { color: string, text: string },
    map: Record<string, { color: string, text: string }>
}

export function macroEnhancedText(vm: Vue, h: any) {
    vm.$set(vm.$data.scope, 'select', null);

    const scopedSlots = {
        default: function (body) {
            const desc = body.desc;


            if (desc.renderer) {
                let { color, text } = desc.renderer(body.row);

                return <span style={'color:' + color}>{text}</span>
            }
            else if (desc.map) {
                if (body.row[desc.prop] in desc.map) {
                    let { color, text } = desc.map[body.row[desc.prop]];

                    return <span style={'color:' + color}>{text}</span>
                }
                else if (desc.map.default) {
                    let { color, text } = desc.map.default;

                    return <span style={'color:' + color}>{text}</span>
                }
            }
        },
    }

    return <colDefiner {...{ scopedSlots }}></colDefiner>;
}